export default {
    // 配置文件
    // http://3v68231q49.qicp.vip/
    // http://124.70.18.25:8001/
    // https://api.zhenbaojia.cn/api
    // http://192.168.31.121:8081
    basUrl: 'http://124.70.18.25:8006/',
}